export default __webpack_public_path__ + "static/default-seo-image1-ef1955df8674756b9c809bc541d5a7ec.jpg";